import { render, staticRenderFns } from "./ZaitonTransferContractDesignV2Arabic.vue?vue&type=template&id=5bdf2054&scoped=true&"
import script from "./ZaitonTransferContractDesignV2Arabic.vue?vue&type=script&lang=js&"
export * from "./ZaitonTransferContractDesignV2Arabic.vue?vue&type=script&lang=js&"
import style0 from "./ZaitonTransferContractDesignV2Arabic.vue?vue&type=style&index=0&id=5bdf2054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdf2054",
  null
  
)

export default component.exports